module.exports = __webpack_public_path__ + "assets/images/icons/blue/icon_vaccine-green.svg?v=6eaececf";